import React from 'react'
import { useSelector } from 'react-redux';
import { MathUtils } from 'three';

const Ferrari = () => {
    const inVRMode = useSelector(state => state.private.device.inVRMode)
    const ferrari = useSelector(state => state.private.ferrari === "y")

    let position = { x: -3.5, y: 1.6, z: 1 };
    let hands = {};
    let rotation = "0 70 0";
    let line = {};

    if (position) {
        if (position.x != null) {
            line.start = position.x + " " + (position.y - 0.35) + " " + position.z;
            position = position.x + " " + position.y + " " + position.z;
        }
        if (rotation._x != null) {
            rotation =
                MathUtils.radToDeg(rotation._x) +
                " " +
                MathUtils.radToDeg(rotation._y) +
                " " +
                MathUtils.radToDeg(rotation._z);
        }
        if (hands.end) {
            line.end = hands.end.x + " " + hands.end.y + " " + hands.end.z;
        }
    }

    return inVRMode && ferrari ? (
        <a-entity class="Player">
            <a-entity position={position} rotation={rotation}>
                <a-entity
                    position="-3 -2.5 4.5"
                    rotation="0 220 0"
                    scale="1 1 1"
                >
                    <a-obj-model
                        shadow=""
                        rotation="0 0 0"
                        src="#ferrari-obj"
                        mtl="#ferrari-mtl"
                    />
                </a-entity>
            </a-entity>
        </a-entity>
    ) : null;
}

export default Ferrari
